import { useId } from "react"

// SVG ids are document-wide: a logo whose gradient or mask points at a copy
// left in a hidden popup renders blank, so every rendered copy gets its own ids
export const useSvgIdPrefix = () => useId().replace(/:/g, "")
